<div class="map" [ngStyle]="{ width: width, borderRadius: '25px' }">
  <ya-map [state]="{ controls: [] }"
    [options]="{ yandexMapDisablePoiInteractivity: false, copyrightLogoVisible: false, copyrightProvidersVisible: false, copyrightUaVisible: false }"
    [center]="coordinates" [zoom]="16">
    <ya-placemark [geometry]="coordinates"></ya-placemark>
  </ya-map>
</div>